import script from "./ClientCreate.vue?vue&type=script&setup=true&lang=ts"
export * from "./ClientCreate.vue?vue&type=script&setup=true&lang=ts"

import "./ClientCreate.vue?vue&type=style&index=0&id=f400080c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f400080c"]])

export default __exports__